// extracted by mini-css-extract-plugin
module.exports = {"container":"Descriptions_container__KbKPH","iconContainer":"Descriptions_iconContainer__2jn7B","icon":"Descriptions_icon___gLdA"};